import React, { Fragment } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { formatMobilePhone } from "utils"
import classes from "./OrderDetailsCustomerInfo.module.scss"

const OrderDetailsCustomerInfo = props => {
  const { order, isOrderAddedByAccess } = props

  const [t, i18n] = useTranslation()

  const systemIsActivated =
    useSelector(state =>
      state.systemSettings.systemIsActivated
    )

  const showOrderNote =
    !!order.note &&
    !isOrderAddedByAccess

  const showCustomerDetails =
    !!order.customerFullName ||
    !!order.customerMobilePhone

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Fragment>
      {
        showCustomerDetails &&
        <div className={classes["container"]}>
          <div className={classes["title"]}>
            {t("اطلاعات_مشتری")}
          </div>

          <div className={clsx(classes["row"], isLtr && classes["row-ltr"])}>
            <span>{t("نام")}:</span>
            <b>{systemIsActivated ? order.customerFullName : "*********"}</b>
          </div>

          <div className={clsx(classes["row"], isLtr && classes["row-ltr"])}>
            <span>{t("موبایل")}:</span>
            <b>
              {systemIsActivated ? formatMobilePhone(order.customerMobilePhone) : "*********"}
            </b>
          </div>
        </div>
      }

      {
        order.addedBySystem &&
        <div className={classes["container"]}>
          <div className={classes["title"]}>
            {t("طریق_سفارش")}
          </div>
          <div className={clsx(classes["row"], isLtr && classes["row-ltr"])}>
            <span>{t("نام")}:{" "}</span>
            <b>{order.addedByFullName}</b>
          </div>
        </div>
      }

      {
        showOrderNote &&
        <div className={classes["container"]}>
          <div className={classes["title"]}>
            {t("توضیحات_سفارش")}
          </div>
          <b className={classes["note"]}>
            {order.note}
          </b>
        </div>
      }

      <div className={classes["container"]}>
        <div className={classes["title"]}>
          {t("جزئیات_شعبه")}
        </div>
        <b className={classes["note"]}>
          {order.branchName}
        </b>
      </div>
    </Fragment>
  )
}

export default OrderDetailsCustomerInfo